import {useMutation, useQuery} from "@apollo/client"
import {DELETE_TERM, UPDATE_TERM} from "./graphql/mutation"
import Cookies from "universal-cookie"
import SpinLoader from "../../components/loaders/SpinLoader"
import {toast} from "react-hot-toast"
import {Link, useNavigate, useParams} from "react-router-dom"
// import {GET_TAG} from "./graphql/query"
import {useInit} from "../../providers/Init"

import Modal from "../../components/Modal"
import {useModal} from "../../providers/Modal"
import {GET_TERM_DETAIL} from "./graphql/query"
import TermForm from "./form/TermForm"

const cookies = new Cookies()

export default function EditTermScreen() {
  const params = useParams()
  const navigate = useNavigate()
  const {modalId, showModal} = useModal()
  const [UpdateTerm, {loading: updateLoading}] = useMutation(UPDATE_TERM)
  const [DeleteTerm, {loading: deleteLoading}] = useMutation(DELETE_TERM)

  const {data, loading} = useQuery(GET_TERM_DETAIL, {
    variables: {
      id: parseInt(params.id),
    },
    fetchPolicy: "no-cache",
  })

  const submitForm = async (values) => {
    values.id = parseInt(params.id)

    await UpdateTerm({
      variables: values,
      onCompleted: (data) => {
        toast.success("Хадгалдлаа")
      },
    })
  }

  return (
    <div className="">
      <div className="gh-canvas-header">
        <div className="gh-canvas-header-content">
          <div className="flex flex-column">
            <h2 className="gh-canvas-title">
              <a href="/settings" className="active ">
                Үйлчилгээний нөхцөл засах
              </a>
            </h2>
          </div>
          <div className="view-actions">
            {data?.GetTermDetail?.id && (
              <button onClick={() => showModal(`deleteTermModal${data?.GetTermDetail?.id}`)} type="button" className="btn  btn-danger">
                Устгах
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="position-relative">
        <SpinLoader loading={loading || updateLoading} absolute small />
        {data?.GetTermDetail && <TermForm submitForm={submitForm} term={data.GetTermDetail} />}
      </div>
      {data?.GetTermDetail && (
        <>
          <Modal id={`deleteTermModal${data?.GetTermDetail?.id}`}>
            <Modal.Body>
              <SpinLoader loading={deleteLoading} absolute />
              <h4>Устгах уу?</h4>

              <div className="d-flex align-items-center justify-content-between mt-4">
                <div className="d-flex align-items-center justify-content-start">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      DeleteTerm({
                        variables: {
                          id: data.GetTermDetail.id,
                        },
                        onCompleted: () => {
                          toast.success("Устгагдлаа")
                          showModal("")
                          navigate("/settings")
                        },
                      })
                    }}
                  >
                    Устгах
                  </button>
                  <button className="btn btn-light ms-2" onClick={() => showModal("")}>
                    Болих
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </div>
  )
}
